import {ROUTES} from '@app/routing/routes';
import {AuthRequest, Profile, TokensData} from '@entities/user/types';
import api from '@shared/api';
import {history} from '@shared/lib/history';

const PATH = '/uaa';

export const authorize = async ({username, password}: AuthRequest) =>
    (await api.post<TokensData>(`${PATH}/auth/login`, {username, password})).data;

export const deauthorize = async (refreshToken: string | null) => {
    if (!refreshToken) return history.push(ROUTES.LOGIN);
    const params = new URLSearchParams();
    params.append('refreshToken', refreshToken);
    await api
        .post(`${PATH}/auth/logout`, params, {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        })
        .catch(console.error);
};

export const fetchProfile = async (token?: TokensData) =>
    (
        await api.get<Profile>(`${PATH}/users/profile`, {
            headers: {...(token?.access_token && {Authorization: `Bearer ${token.access_token}`})},
        })
    ).data;

export const verifyMfa = async (payload: any) =>
    api.post(`${PATH}/registration/mfa/verify`, payload);

export const createMfa = async (payload: any) =>
    api.post<string>(`${PATH}/registration/mfa`, payload);
